<template>
  <div v-if="item.title" class="py-10 py-md-12 py-lg-14 grid">
    <v-sheet
      v-if="item.img"
      class="d-flex align-center grid-item"
      color="#f8f8f8"
      height="100%"
    >
      <v-row justify="center" justify-md="end" no-gutters>
        <v-col cols="8" sm="5" md="10" lg="8" xl="7">
          <img
            :src="files + item.img"
            :alt="item.title"
            class="d-block pa-5 pa-md-10 item-img"
            width="100%"
          />
        </v-col>
      </v-row>
    </v-sheet>

    <v-sheet
      class="d-flex align-center py-10 grid-item"
      :class="{ 'left-rounded': item.img }"
      color="#2d6da7"
      height="100%"
    >
      <v-row class="relative" no-gutters>
        <v-col cols="12" lg="8" xl="7">
          <v-sheet
            class="
              text-center text-md-left
              mx-auto mx-md-0
              font-montserrat
              item-title
            "
            color="transparent"
            max-width="380px"
            v-html="item.title"
          ></v-sheet>

          <div
            v-if="item.text"
            class="
              px-3 px-md-0
              text-center text-md-left
              mt-4
              font-montserrat
              item-text
            "
            v-html="item.text"
          ></div>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
const _config = {
  mod: "protocolAngels",
};

export default {
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: 45% 55%;
  justify-self: center;

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr;
  }

  &-item {
    &.left-rounded {
      padding-left: 100px;
      position: relative;

      @media screen and (max-width: 960px) {
        padding-left: 0;
        padding-top: 150px !important;
      }

      &:before {
        background-image: url(/img/bg/protocol.png);
        background-position: left center;
        background-repeat: no-repeat;
        background-size: contain;
        bottom: 0;
        content: "";
        left: 0;
        position: absolute;
        right: 0;
        top: 0;

        @media screen and (max-width: 960px) {
          background-image: url(/img/bg/protocol-top.png);
          background-position: top center;
        }
      }
    }

    .item-img {
      @media screen and (max-width: 960px) {
        margin-bottom: -40px;
        position: relative;
        z-index: 10;
      }
    }

    .item-title::v-deep {
      color: white;
      font-size: 30px;
      font-weight: 900;
      line-height: 37px;

      big {
        display: block;
        font-size: 38px;
        line-height: 46px;
      }
    }

    .item-text {
      color: white;
      font-size: 18px;
      line-height: 27px;
      letter-spacing: 0.5px;
    }
  }
}
</style>
